import React, { Dispatch, SetStateAction, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import Slider from 'rc-slider';

type MOStep4Props = {
	setCurrentStep: Dispatch<SetStateAction<number | string>>;
	membershipQuestions: any;
	setMembershipQuestions: Dispatch<any>;
};

export const MOStep4: React.FC<MOStep4Props> = ({
	setCurrentStep,
	membershipQuestions,
	setMembershipQuestions,
}) => {
	const [initialDetails, setInitialDetails] = useState<any>(membershipQuestions);	

	const validationSchema = Yup.object({
		pupilsOnRoll: Yup.number().min(1, 'Please select a number of pupils on roll').required('Please select a number of pupils on roll').nullable(),
	});	

	const handleSubmit = async (values: any) => {
		setMembershipQuestions(values);
		setCurrentStep(5);
	};

	return (
		<>
			<div className="MOSpeechBubbleQuestion">
				<div className="SpeechBubbleQ">
					<h1>How many pupils do you have on roll?</h1>
				</div>
			</div>

			<Formik
				initialValues={initialDetails}
				onSubmit={handleSubmit}
				validateOnChange={false}
				validateOnBlur={false}
				validateOnMount={false}
				enableReinitialize={true}
				validationSchema={validationSchema}
			>
				{(formik) => {
					return (
						<Form>
							<div className="MOQForm">
								{formik.errors.pupilsOnRoll && <p className="ErrorTxt">{(formik as any).errors.pupilsOnRoll}</p>}
								<div className="PupilsNoSlider">
									<div className="LeftVal">0</div>
									<div className="MiddleSlider">
										<Slider
											handleRender={ renderProps => (
												<div { ...renderProps.props }>
													<div 
														className="PSTooltip"
														data-slider-tooltip={ renderProps.props["aria-valuenow"] }
													>
														{renderProps.props["aria-valuenow"]}
													</div>
												</div>
											) }
											max={1000}
											onChange={(e) => formik.setFieldValue("pupilsOnRoll", e)}
											value={formik.values.pupilsOnRoll}
											step={1}
										/>
									</div>
									<div className="RightVal">1000+</div>
								</div>

								<div className="Btn BtnOrange SubmitBtn" onClick={formik.submitForm}>Next question</div>
								<div className="Btn BtnWhite BackBtn" onClick={() => setCurrentStep(3)}>Back</div>
							</div>
						</Form>
					);
				}}
			</Formik>
		</>
	);
};